import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../../Routes/routes';
import { captureButtonPress } from '../../../../features/analytics';
import { NewButton } from '../../../NewButton';
import { unlock } from '../../../../features/audio/howlerSetup';
import { useTranslation } from 'react-i18next';
import { env } from '../../../../App/config/env';
import styled from 'styled-components';

interface Props {
  tourID: string;
}

export const TourWidgetNewContinueTourButton: React.FC<Props> = ({
  tourID,
}) => {
  const { t } = useTranslation();
  const page = window.location.pathname;
  const history = useHistory();

  const handleGoToGateButtonClick = () => {
    unlock();

    captureButtonPress({
      buttonName: 'ContinueTour',
      tourID,
      page,
    });

    history.push(ROUTES.tour, { playlistID: tourID });
  };

  return (
    <NewButton
      width="100%"
      minWidth="120px"
      onClick={handleGoToGateButtonClick}
    >
      {t(env.APP_ENV.text.continueTourCaption)}
    </NewButton>
  );
};

export const NewStyledButton = styled.div`
  border-radius: 20px;
  cursor: pointer;
`;
